import React, { useState } from "react";
import styled from "styled-components";
import { colors } from "utils";
import { interText } from "components/pages/WarmUpPicker/styles";
import { CreateGroupsMenuButton } from "./CreateGroupsMenuButton";
import { CreateGroupsTip, CreateGroupsTipCopy, DEFAULT_LESSON_GROUPS_DETAIL } from "./createGroupsTip";
import { InfoLucideIcon } from "./oneListIcons";

// Under the Filter row (Figma 6141:4213): the class's free codes on the left;
// Create Groups and its info button on the right.
const TIP_ID = "one-list-create-groups-tip";

// Shown while the icon is hovered or focused; absent otherwise.
const CreateGroupsInfo = ({ lessonGroupsDetail }) => {
  const [open, setOpen] = useState(false);
  const show = () => setOpen(true);
  const hide = () => setOpen(false);
  return (
    <InfoWrap onMouseEnter={show} onMouseLeave={hide} onFocus={show} onBlur={hide}>
      <InfoButton type="button" aria-label="About creating groups" aria-describedby={open ? TIP_ID : undefined}>
        <InfoLucideIcon />
      </InfoButton>
      {open && (
        <RightAlignedTip id={TIP_ID} role="tooltip">
          <CreateGroupsTipCopy lessonGroupsDetail={lessonGroupsDetail} warmUpGroups />
        </RightAlignedTip>
      )}
    </InfoWrap>
  );
};

export const OneListCtaRow = ({ available, total, createMenu, lessonGroupsDetail = DEFAULT_LESSON_GROUPS_DETAIL }) => (
  <Row>
    <Status aria-live="polite" aria-atomic="true">{`${available} of ${total} Group Codes Available`}</Status>
    <Actions>
      <CreateGroupsMenuButton {...createMenu} />
      <CreateGroupsInfo lessonGroupsDetail={lessonGroupsDetail} />
    </Actions>
  </Row>
);

const Row = styled.div`
  align-items: center;
  display: flex;
  height: 48px;
  justify-content: space-between;
  margin-top: 16px;
`;

const Status = styled.div`
  ${interText(18, 26)}
  color: ${colors.nightlyWoods500};
  white-space: nowrap;
`;

const Actions = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

// Today's bubble, opened below the icon and aligned to its right edge so it
// stays inside the window (the icon sits at the row's right end).
const RightAlignedTip = styled(CreateGroupsTip)`
  display: block;
  left: auto;
  right: 0;
  transform: none;

  &::before {
    left: auto;
    right: 4px;
    transform: none;
  }
`;

const InfoWrap = styled.span`
  display: inline-flex;
  position: relative;
`;

const InfoButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  height: 24px;
  padding: 0;
  width: 24px;
`;
